"use client";

import Image from "next/image";
import { ArrowRight } from "lucide-react";

import type { CoreServiceWithPlans } from "@/app/_lib/db/core-service";

const cloud = (id: string) =>
  `https://res.cloudinary.com/${process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME}/image/upload/${id}`;

/** "More services" card — image with a "Continue" pill, used on /services and the homepage. */
export function ServiceCard({
  service,
  onOpen,
}: {
  service: CoreServiceWithPlans;
  onOpen: () => void;
}) {
  return (
    <button
      onClick={onOpen}
      className="group flex flex-col gap-4 border border-border bg-background  text-left transition hover:border-primary/40"
    >
      <div className="flex flex-col gap-3 p-7">
        <h3 className="line-clamp-2 text-2xl leading-snug">
          <span className="font-semibold">{service.title}.</span>{" "}
          <span className="text-muted-foreground">{service.description}</span>
        </h3>

        {service.plans[0] && (
          <p className="line-clamp-2 text-[#707070] text-base">
            {service.plans[0]?.description}
          </p>
        )}
      </div>

      <div className="relative h-80 overflow-hidden bg-mint mt-auto">
        <Image
          src={cloud(service.image)}
          alt={service.title}
          fill
          sizes="(min-width: 640px) 50vw, 100vw"
          className="object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="inline-flex absolute bottom-5 left-5 items-center gap-1.5 self-start rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground">
          Continue <ArrowRight size={14} />
        </span>
      </div>
    </button>
  );
}
